'use client';

import type { CustomerSession } from '@dobrozem/sdk';
import { createContext, type ReactNode, useContext } from 'react';
const AuthContext = createContext<{
  session: CustomerSession | null;
}>({
  session: null
});
export const AuthProvider = ({
  children,
  session
}: {
  children: ReactNode;
  session: CustomerSession | null;
}) => {
  return <AuthContext.Provider value={{
    session
  }} data-sentry-element="unknown" data-sentry-component="AuthProvider" data-sentry-source-file="AuthProvider.tsx">{children}</AuthContext.Provider>;
};
export const useSession = () => {
  return useContext(AuthContext).session ?? null;
};
export const useUser = () => {
  return useContext(AuthContext).session?.customer ?? null;
};
export const useUserEnsured = () => {
  const customer = useContext(AuthContext).session?.customer;
  if (!customer) throw new Error('No customer');
  return customer;
};